import cardHeaderClasses from "@mui/material/CardHeader/cardHeaderClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { cardHorizontalContentClasses } from "../CardHorizontalContent/CardHorizontalContent.styled";
export const MuiCardHeaderTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                alignItems: "flex-start",
                gap: dt.space.inline.small,
                paddingTop: dt.space.stack.small,
                paddingRight: dt.space.stack.small,
                paddingBottom: dt.space.stack.xSmall,
                paddingLeft: dt.space.stack.small,
                [`.${cardHorizontalContentClasses.root} &`]: {
                    padding: 0,
                },
                [`.${cardHeaderClasses.title}`]: typographyResponsive(dt, "body1.bold"),
                [`.${cardHeaderClasses.subheader}`]: typographyResponsive(dt, "body2.regular"),
                [`.${cardHeaderClasses.title}:empty`]: { display: "none" },
                [`.${cardHeaderClasses.subheader}:empty`]: { display: "none" },
                [`.${cardHeaderClasses.avatar}`]: {
                    margin: 0,
                },
                [`.${cardHeaderClasses.action}`]: {
                    margin: 0,
                },
                [`.${cardHeaderClasses.content}`]: {
                    display: "flex",
                    flexDirection: "column",
                    gap: dt.stacked.xSmall,
                },
                ".Pxl-Card-horizontal &": {
                    paddingBottom: 0,
                },
            },
        },
    };
};
